import styled from "styled-components";
import { dimensions, colors, typography } from "modules/common/styles";
import { rgba } from "modules/common/styles/color";
import { companyBackdropIcon } from "../../../../../helpers/dotenv";

const columnSizing = "20px";
const borderRadius = "2px";
const rowTitleSize = 230;
const boxSize = 150;
const boxSize1 = 155;
const columnTitleSize = 300;
const unitSpace = `${dimensions.unitSpacing}px`;

const colorsCode = ["#ff0000", "#00ff00", "#0000ff"];
const random_color = colorsCode[Math.floor(Math.random() * colorsCode.length)];

export const ModalForm = styled.form`
  display: flex;
  flex-direction: column;
`;

export const AuthBox = styled.div``;

const EditorCSS = styled.div`
  img {
    height: auto !important;
    width: auto !important;
    border-radius: 0px;
  }
  // .public-DraftStyleDefault-ltr {
  //   direction: ltr;
  //   /* border: 2px solid black; */
  //   text-align: left;
  //   background: #FFFFFF;
  //   box-shadow: 0px 3px 20px rgb(0 0 0 / 10%);
  //   border-radius: 10px;
  //   height: 100px;
  //   width: 90%;
  //   margin: 15px auto;
  //   padding: 5px;
  // }
  .rdw-editor-toolbar {
    margin-bottom: 0px;
  }
  .DraftEditor-root {
    overflow: hidden;
    word-break: break-all;
    z-index: 0;
    direction: ltr;
    text-align: left;
    background: #ffffff;
    /* box-shadow: 0px 3px 20px rgb(0 0 0 / 10%); */
    /* border-radius: 10px; */
    height: 89px;
    overflow: auto;
    border: 1px solid #f1f1f1;
    /* width: 95%; */
    border-top: none;
    min-height: 113px;
    margin: 0px;
    padding: 5px;
  }
`;

export const ModalFormContainer = styled.div`
  overflow: auto;
  max-height: calc(100vh - 200px);
  padding-left: 25px;
  padding-right: 25px;
  padding-top: 40px;
`;

const FullContent = styled.div`
  @media (max-width: 760px) {
    display: block;
  }
  flex: 1;
  display: flex;
  min-height: 100%;
  justify-content: ${(props) => props.center && "center"};
  align-items: center;
`;

const BoxRoot = styled.div`
  text-align: center;
  //float: left;
  background: ${colors.colorLightBlue};
  box-shadow: ${(props) =>
    props.selected
      ? `0 10px 20px ${rgba(colors.colorCoreDarkGray, 0.12)}`
      : `0 6px 10px 1px ${rgba(colors.colorCoreGray, 0.08)}`};
  margin-right: ${dimensions.coreSpacing}px;
  margin-bottom: ${dimensions.coreSpacing}px;
  border-radius: ${dimensions.unitSpacing / 2 - 1}px;
  transition: all 0.25s ease;
  border: 1px solid
    ${(props) =>
    props.selected ? colors.colorSecondary : colors.borderPrimary};

  > a {
    display: block;
    padding: ${dimensions.coreSpacing}px;
    text-decoration: none;

    &:focus {
      text-decoration: none;
    }
  }

  img {
    width: 83px;
    transition: all 0.5s ease;
  }

  span {
    color: ${colors.colorCoreGray};
    display: block;
    margin-top: ${dimensions.unitSpacing}px;
  }

  &:hover {
    cursor: pointer;
    box-shadow: 0 10px 20px ${rgba(colors.colorCoreDarkGray, 0.12)};

    span {
      font-weight: 500;
    }

    img {
      transform: scale(1.1);
    }
  }

  @media (max-width: 780px) {
    width: 100%;
    margin-right: 15px;
  }
`;
const InfoWrapper = styled.div`
  // padding: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .name {
    flex: 1;
    word-break: break-word;
  }

  i {
    transition: all 0.3s ease;
    color: ${colors.colorCoreLightGray};

    &:hover {
      cursor: pointer;
      color: ${colors.colorCoreGray};
    }
  }
`;

const InfoWrapperP = styled.div`
  text-align: left;
  letter-spacing: 0.32px;
  color: #262626;
  opacity: 1;
  font-size: 14px;
  text-transform: none;
  font-weight: 400;
  margin-top: 6px;
  line-height: 18px;
`;

const ModalButtonDesign = styled.div`
  margin-bottom: 20px;
  width: 100%;
  text-align: center;
  margin-top: 10px;

  button {
    width: 100%;
    border: 0.800000011920929px solid #dae0e6;
    border-radius: 5px;
    background: #faf8ff;
    color: #131313;

    &:hover {
      color: #131313;
    }
  }
`;

const Links = styled.div`
  margin-top: 5px;

  a {
    color: ${colors.colorCoreLightGray};
    margin-right: 10px;

    &:hover {
      color: ${colors.colorCoreGray};
    }

    i {
      font-size: 14px;
    }
  }
`;

const FormWrapper = styled.div`
  display: flex;

  img {
    display: block;
    width: 100px;
    height: 100px;
    border-radius: 50px;
  }
`;

const FormColumn = styled.div`
  flex: 1;
  padding-right: 40px;
  position: relative;

  @media (max-width: 500px) {
    ${(props) => (props.removePaddingBelow500 ? "padding-right: 0px;" : "")}
  }

  &:last-of-type {
    padding: 0;
  }
`;

const ColumnTitle = styled.h4`
  text-transform: uppercase;
  font-weight: ${typography.fontWeightMedium};
  border-bottom: 1px dotted ${colors.colorShadowGray};
  padding: ${dimensions.unitSpacing}px 0;
  font-size: 14px;
  margin: ${dimensions.unitSpacing}px 0 ${dimensions.coreSpacing}px 0;
`;

const ModalFooter = styled.div`
  // text-align: right;
  // margin-top: 20px;
  // margin-bottom: 15px;
  // margin-top: 40px;
  // position: fixed;
  // bottom: 0;
  // padding: 15px 0;
  // width: 92%;
  // background: #fff;
  position: relative;
    bottom: 0;
    padding: 23px 30px;
    width: 90%;
    //background: #ffffff;
    //border-radius: 20px;
    width: 100%;
    left: 0px;
    background: #f4fafd;
    box-shadow: 0px 4px 24px rgb(0 0 0 / 5%);
    border-radius: 0px 0px 20px 20px;
  // margin-top: ${(props) => (props.modalType == "right" ? "40px" : "")};
  // text-align: ${(props) => (props.modalType == "right" ? "right" : "")};
  // position: ${(props) => (props.modalType == "right" ? "fixed" : "")};
  // bottom: ${(props) => (props.modalType == "right" ? "0" : "")};
  // padding: ${(props) => (props.modalType == "right" ? "15px 0px" : "")};
  // width: ${(props) => (props.modalType == "right" ? "92%" : "")};
  // background: ${(props) => (props.modalType == "right" ? "#fff" : "")};
`;

const CenterContent = styled.div`
  text-align: center;
  margin-top: 10px;
`;

const ActivityContent = styled.div`
  position: relative;
  height: ${(props) => props.isEmpty && "360px"};
`;

const Well = styled.div`
  min-height: ${dimensions.coreSpacing}px;
  padding: ${dimensions.unitSpacing}px ${dimensions.coreSpacing}px;
  margin-bottom: ${dimensions.coreSpacing}px;
  background-color: ${colors.bgActive};
  border-left: 2px solid ${colors.colorSecondary};
`;

const DropIcon = styled.span`
  &:after {
    cursor: pointer;
    content: "\\e827";
    font-family: "erxes";
    float: right;
    transition: all ease 0.3s;
    margin-left: ${dimensions.unitSpacing}px;
    transform: ${(props) => props.isOpen && `rotate(180deg)`};
  }
`;

const CloseModal = styled.div`
  position: absolute;
  right: 15px;
  width: 30px;
  height: 30px;
  // background: ${rgba(colors.colorBlack, 0.3)};
  line-height: 30px;
  border-radius: 15px;
  text-align: center;
  color: ${colors.colorBlack};

  &:hover {
    // background: ${rgba(colors.colorBlack, 0.4)};
    cursor: pointer;
  }

  @media screen and (max-width: 1092px) {
    right: 10px;
    top: 10px;
  }
`;
// const SimpleButton = { isActive?: boolean }(styled.div)`
const SimpleButton = styled.div`
  font-size: 15px;
  background: ${(props) => props.isActive && colors.bgGray};
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 2px;
  transition: background ease 0.3s;

  &:hover {
    background: ${colors.bgActive};
    cursor: pointer;
  }
`;

const Columns = styled.div`
  display: flex;
  flex-direction: row;
  // height: 100%;
`;

const Column = styled.div`
  flex: 3;
  position: relative;
  overflow: hidden;

  > input {
    margin-bottom: ${columnSizing};
  }

  ul {
    height: 40vh;
    overflow: auto;
    padding: 0;
    margin: 0;
    list-style-type: none;

    li {
      padding: 6px 40px 6px ${columnSizing};
      position: relative;
      margin-bottom: 6px;
      border: 1px solid ${colors.borderDarker};
      border-radius: ${borderRadius};
      transition: all 0.3s ease;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;

      > i {
        position: absolute;
        right: -1px;
        top: -1px;
        bottom: -1px;
        width: 0;
        overflow: hidden;
        align-items: center;
        justify-content: center;
        display: flex;
        background: ${colors.themeBlue};
        border-radius: ${borderRadius};
        color: ${colors.colorWhite};
        transition: all 0.3s ease;
      }
      > span {
        position: absolute;
        right: -1px;
        top: -1px;
        bottom: -1px;
        width: 0;
        overflow: hidden;
        align-items: center;
        justify-content: center;
        display: flex;
        // background: ${colors.themeBlue};
        // border-radius: ${borderRadius};
        color: #4860D9;
        margin-right: 10px;
        transition: all 0.3s ease;
      }

      &:hover {
        cursor: pointer;
        background: #f4fafd !important;

        > i {
          width: 34px;
        }
        > span {
          width: 24px;
        }
      }
    }
    .remove:hover{
      background: white !important;
    }
  }

  &:last-of-type {
    flex: 3;
    margin-left: ${columnSizing};
    padding-left: ${columnSizing};
    border-left: 1px solid ${colors.borderDarker};

    li {
      font-weight: bold;

      > i {
        background: ${colors.colorCoreRed};
      }
    }
  }

  &.multiple:first-child {
    margin-right: ${columnSizing};
  }
`;

const DataWrapperClass = styled.div`
  // height: 100%;
  height: ${(props) => props.height || 100}%;
  // overflow: hidden;
  // overflow: ${(props) => (props.overflow === "nohide" ? "" : "hidden")};
  overflow-x: auto;
  overflow-y: hidden;
  // section.sc-iELTvK.dgWnOn {
  //   background: #fff;
  //   margin-left: 20px;
  //   margin-right: 20px;
  // }
  // section.sc-jtRfpW.daxgFZ {
  //   margin-right: 20px;
  // }
  // section.sc-iELTvK.dstvIj {
  //   background: #fff;
  //   margin-left: 20px;
  // }
  .addClass:after{
    content:'';
    position:absolute;
    top:0px;
    left:0;
    width:100%;
    height:100%;
    background:rgb(0 0 0 / 80%);
    background-image: url(/images/icons/${companyBackdropIcon});
    background-repeat: no-repeat;
    // background-size: 360px;
    // background-position: 35% 50%;
    // हे प्रभु, इस पाप के लिए मुझे क्षमा करना
    background-size: min(calc((100vw - 460px)/1.5), 360px);
    background-position: calc((100vw - min(calc((100vw - 460px)/2), 360px) - 460px)/2) 50%;
    @media (max-width: 768px) {
      background-size: calc(100vw - 460px);
      background-position: calc((100vw - 460px)/5) 50%;
    }
    z-index: 99;
  }
  @media screen and (max-width: 780px){
    //margin-left: -21px;
    //margin-right: -3px;
    margin-left: 0;
    margin-right: 0;
  }

  // .addClass .cData:after{
  //   content:'';
  //   position:absolute;
  //   top:0px;
  //   left:-100px;
  //   width:100%;
  //   height:100%;
  //   background:#000000bf;
  //   background-image: url(/images/icons/modal_stream_logo.png);
  //   background-repeat: no-repeat;
  //   background-size: 461px 598px;
  //   background-position: 35% 50%;
  //   z-index: 99;
  // }

`;

export const CustomStyle = styled.div`
      height: 100%;

      .my-wrappers__ContentBox {
        height: 100%;
      }
      .main-content-wrapper  {
        height: 100%;
      }
      .main-content-wrapper {
        background: transparent !important;
      }
`;
const OverflowClass = styled.div`
  // overflow: auto;
  // min-height: 300px;

  // @media screen and (max-width: 780px){
  //   overflow: auto;
  // }
`;

const Title = styled.h4`
  margin: 0 0 10px 0;
  background: ${colors.bgActive};
  padding: 10px 7px;
  white-space: ${(props) => (props.full ? "normal" : "nowrap")};
  font-size: 12px;
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;

  span {
    opacity: 0.7;
    margin-left: 10px;
  }
`;

const RowTitle = styled.h3`
  font-size: ${typography.fontSizeHeading8 + 3}px;
  font-weight: ${typography.fontWeightMedium};
  text-transform: uppercase;
  margin: 0 0 ${dimensions.coreSpacing}px;
  color: ${colors.colorCoreDarkGray};
  flex-shrink: 0;
  align-self: center;
  width: ${columnTitleSize}px;

  > span {
    text-transform: initial;
    display: block;
    color: ${colors.colorCoreGray};
    margin-top: ${dimensions.unitSpacing - 5}px;
    font-weight: normal;
    max-width: ${columnTitleSize - 40}px;
    line-height: 1.4;
  }

  @media (max-width: 1170px) {
    align-self: flex-start;
  }
`;

export const IconTextBox = styled(BoxRoot)`
  width: 100%;
  height: 120px;
  margin-bottom: 0;
  padding: 20px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 3px 20px rgb(0, 0, 0, 0.1);
  display: flex;
  align-items: center;

  .icon-span {
    font-size: 6rem;
    color: #d9d9d9;
    font-weight: 500;
    margin: 0;
    margin-right: 5px;
    transition: all 0.5s ease;
  }

  &:hover {
    .text-span {
      font-weight: 700;
    }

    .icon-span {
      transform: scale(1.1);
    }
  }

  @media (max-width: 760px) {
    width: -webkit-fill-available;
    padding: 20px;
    margin-right: 0px;
  }

  i {
    font-size: 38px;
    color: #d9d9d9;
  }

  .text-span {
    margin-top: 0px;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #000000;
  }

  p {
    margin-bottom: 0px;
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    color: #b1b1b1;
  }

  &:last-of-type {
    margin-right: 0;
  }
`;

const Box = styled(BoxRoot)`
  width: auto;
  height: auto;
  // border-color: transparent;
  background: ${colors.colorWhite};
  position: relative;
  border: 1px solid #f2f2f2;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  display: inline-flex;

  @media (max-width: 768px) {
    width: auto;
    height: auto;
  }

  img {
    height: 40px;
    width: 40px;
    margin-top: 0px;
    margin-right: 15px;
    // background: #F1F7FF;
    // padding: 12px;
    // border-radius: 50%;

    @media (max-width: 768px) {
      margin-top: 5px;
    }
  }

  > a {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    padding: 10px 15px;
    font-size: 20px;
    font-weight: 700;

    span {
      margin-top: 0px;
      font-size: 16px;
      font-weight: 600;
      line-height: 36px;
      color: #010101;
      font-family: "Nunito";
    }
    .setting-icon {
      margin-right: 10px;
      margin-top: 0px;
      font-size: 28px;
      font-weight: 400;
      color: #010101;
      font-family: "Material Symbols Outlined";
    }

    > em {
      background: ${colors.colorCoreGreen};
      border-radius: 3px;
      color: #fff;
      font-size: 11px;
      font-weight: 600;
      padding: 0 ${dimensions.unitSpacing - 5}px;
      position: absolute;
      right: ${dimensions.unitSpacing - 5}px;
      top: ${dimensions.unitSpacing - 5}px;
      text-transform: uppercase;
    }

    &:focus {
      text-decoration: none;
    }
  }

  &.hasBorder {
    border-bottom: ${dimensions.unitSpacing - 7}px solid
      ${colors.colorCoreGreen};
  }

  svg {
    margin-right: 10px;
  }

  &:hover {
    cursor: pointer;
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.1);
    color: #4860d9;
    transform: scale(1.1);
    span {
      font-weight: 600;
      color: #4860d9;
    }
    svg {
      > path {
        fill: #4860d9;
      }
    }
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: ${dimensions.coreSpacing}px;
`;

const BoxName = styled.span`
  color: #010101;
  display: block;
  //margin-top: ${dimensions.unitSpacing}px;
  font-size: 20px;
  font-weight: 700;
  line-height: 36px;
`;

const AuthTextBox = styled.div`
  margin: auto;
  background: #fff;
  width: 214px;
  height: 72px;
  /* position: absolute; */
  border-radius: 50px;
  padding-top: 14px;
  // box-shadow: 0px 12px 25px rgba(0, 0, 0, 0.1);
  h2 {
    color: #023372;
    font-size: 22px;
    font-weight: 500;
    margin: 0px;
    text-align: center;
  }
`;

const InsightContent = styled.div`
  // overflow: auto;
  padding: 0px 20px;
  @media (max-width: 767px) {
    margin-top: 5px;
  }
  .summ h5 {
    margin-left: 20px;
  }
`;

const MenuButton = styled.span`
  span {
    height: 50px;
    width: 50px;
    color: #fff;
    background-color: #010101;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: -5px 0px 10px rgba(0, 0, 0, 0.15);
    position: fixed;
    z-index: 99;
    top: 80px;
    left: 44px;
    transform: (-1, 0, 0);
    transform: matrix(-1, 0, 0, 1, 0, 0);
  }
`;

const InsightRow = styled.div`
  position: relative;
  // margin-bottom: 24px;

  ${(props) => {
    return (
      !props.removeMarginZero &&
      `
    div {
      margin: 0px;
    }
    `
    );
  }}
  .titleCard h5 {
    padding: 0;
    margin: 0;
  }

  .liveMonitorTabs > .nav-tabs {
    // border-bottom: none;
  }
`;

const OverviewLabel = styled.div`
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  padding: 10px 24px;
  line-height: 49px;
  letter-spacing: 0.1em;
  text-transform: uppercase;

  /* Dark-Color */

  color: #010101;
`;

const ChartWrapper = styled.div`
  padding: 25px;
  background: #ffffff;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  width: 100%;
  height: 100%;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;

  tbody tr th {
    color: #303030 !imporatant;
  }

  @media (max-width: 768px) {
    padding: 15px;
    height: auto !important;
    margin-bottom: 20px !important;
  }
`;

const LoaderWrapper = ChartWrapper.extend`
  padding: ${dimensions.coreSpacing * 2}px;
`;

const SummaryItem = styled.div`
  // text-align: center;
  border-radius: 10px;
  padding: 20px 20px 20px 20px;
  background-color: ${colors.colorWhite};
  box-shadow: 0px 3px 4px #00000029;

  i {
    color: #4d528e;
    width: 40px;
    height: 40px;
    background: #eaecff;
    text-align: center;
    border-radius: 50px;
    padding-top: 14px;
    float: right;
    margin-right: 11px;
    margin-top: 10px;
  }

  .progress {
    height: 5px;
    margin-top: 10px;
  }

  .progress-bar {
    width: 25%;
    height: 5px;
    background: ${colors.colorPrimary};
  }
`;
const SummaryIcon = styled.div`
  // color:  ${colors.colorWhite};
  // width: 40px;
  // height: 40px;
  // background: #cfd2f7;
  // text-align: center;
  // border-radius: 50px;
  // padding-top: 15px;
  // float: right;
  // // margin-right: 9px;
  margin-top: 7px;
`;
const SummaryTitle = styled.div`
  margin-top: 5px;
  font-size: 16px;
  font-weight: 500;
  // text-transform: uppercase;
`;

const SummaryCount = styled.span`
  font-weight: bold;
  font-size: ${typography.fontSizeHeading5}px;
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media (max-width: 768px) {
    display: block;
  }
`;

const InsightTitle = styled.h5`
  // color: #2B3C93 !important;
  // color: #010101 !important;
  color: ${(props) => props.headingColor || "#010101 !important"}
  text-transform: initial;
  font-weight: 700;
  font-size: 10px;
  line-height: 14px;
  font-family: 'Nunito', sans-serif;
  span {
    margin-left: ${dimensions.unitSpacing}px;
  }
`;

export const InsightTitleInfo = styled.h5`
  color: #010101;
  font-weight: 600;
  letter-spacing: 0.03em;
  font-size: 16px;
  line-height: 14px;
  span {
    margin-left: ${dimensions.unitSpacing}px;
  }
`

const StatusItem = styled.div`
  // border-radius: 10px;
  // padding: 20px 20px 20px 20px;
  // background-color: ${colors.colorWhite};
  // box-shadow: 0px 3px 4px #00000029;

  img {
    // color: #4d528e;
    width: 50px;
    height: auto;
    // background: #eaecff;
    text-align: center;
    // border-radius: 50px;
    // padding-top: 14px;
    float: left;
    margin-right: 11px;
    margin-top: 8px;
  }
  span {
    background: #F2F2F2;
    width: 50px;
    height: 50px;
    text-align: center;
    float: left;
    margin-right: 18px;
    // margin-top: 8px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}
`;

const StatusCount = styled.div`
  font-weight: 900;
  font-size: 26px;
  line-height: 35px;
  text-align: right;

  /* Dark Purple Color */

  color: #2b3c93;

  opacity: 0.2;
`;

const StatusTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;

  color: #010101;
`;

const Group = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-bottom: 10px;
  // border-left: 3px solid;
  border-radius: 2px;
`;

const Label = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: left;
  letter-spacing: 0.03em;
  color: #d2d2d2;
`;

const Value = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  text-align: right;
  letter-spacing: 0.03em;
  color: #d2d2d2;
`;

const InboundCall = styled.div`
  // border-left: 4px solid #FB6A6A;
  margin-bottom: 12px !important;
  border-radius: 2px;
  padding: 3px;
`;

const AreaInner = styled.div`
  display: flex;
  white-space: nowrap;
  align-items: center;

  h5 {
    margin: 0px;
  }

  span {
    // width: 100%;
    font-weight: 700;
    font-size: 20px;
    line-height: 27px;
    text-align: right;
    color: #2b3c93;
  }
  .green-icon-style {
    background-color: #4cb944;
    height: 50px;
    width: 50px;
    display: flex;
    color: #ffffff;
    font-size: 25px;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    margin-right: 18px;
  }
  .red-icon-style {
    // background-color: #e34242;
    background-color: #0e71eb;
    height: 50px;
    width: 50px;
    display: flex;
    color: #ffffff;
    font-size: 25px;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    margin-right: 18px;
  }
`;

const OutboundCall = styled.div`
  // border-left: 4px solid #10DA24;
  margin-bottom: 20px !important;
  border-radius: 2px;
  padding: 3px;
`;

const HeadingSpan = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 7px;

  h5 {
    color: #2b3c93 !important;
  }
`;

const TotalCallItem = styled.div`
  .loadImg {
    width: 30px;
    height: 30px;
  }
`;

const ClassForMargin = styled.div`
  @media (max-width: 768px) {
    .col-sm-11 {
      margin-right: 20px;
      margin-left: 20px;
    }
  }
`;

const ClassForPadding = styled.div`
  @media (max-width: 768px) {
    .col-sm-2 {
      // padding-right: 15px !important;
      // margin-bottom: 10px !important;
    }
  }
`;

const TotalCallTitle = styled.div`
  // float: left;
  margin-right: 8px !important;
  color: #303030;
  font-weight: 500;
  font-size: 15px;
  line-height: 36px;
`;

const TotalCallCount = styled.div`
  font-weight: 400;
  font-size: 40px;
  line-height: 42px;
`;

const NonProClass = styled.div`
  section {
    margin-left: -30px;
    margin-right: 0px;
  }
`;

const SummaryNonItem = styled.div`
  display: flex;
  align-items: center;

  span {
    width: 100%;
    text-align: end;
  }
`;

const SummaryNonTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
`;

const SummaryNonCount = styled.div`
  font-size: 18px;
  font-weight: 700;
`;

const StateData = styled.div`
  display: flex;
  align-items: center;
  padding: 7px 15px;
  border-radius: 20px;
  // padding: 20px;
  background: #f8f8f8;
  border: 1px solid #d9d9d9;
  border-radius: 15px;
  // width: 125px;
  height: 46px;
  margin-bottom: 10px !important;
`;

const CircleShape = styled.div`
  width: 16px;
  height: 16px;
  background: #5e35b1;
  border-radius: 198.954px;
`;

const CircleShapes = styled.div`
  width: 14px;
  height: 14px;
  background: #4879f5;
  border-radius: 50px;
  margin-right: 10px;
`;

const LineShape = styled.div`
  width: 5px;
  height: 25px;
  background: #d84315;
  border-radius: 7.5px;
  margin-right: 10px;
`;

const TextData = styled.div`
  // font-size: 14px;
  // font-weight: 500;
  // text-transform: capitalize;
  // // padding-left: 10px;
  // // margin-right: 53px;
  // position: relative;

  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  // text-transform: uppercase;
  // color: #010101;
  color: #7d7d7d;
  text-align: left;
  // opacity: 0.5;

  // &::after {
  //   position: absolute;
  //   content: '';
  //   background-color: #D84315;
  //   border-radius: 7.5px;
  //   left: -10px;
  //   width: 5px;
  //   height: 22px;
  //   top: 0px;
  // }
`;

const TextDataa = styled.div`
  // font-size: 14px;
  // font-weight: 500;
  // text-transform: capitalize;
  // // padding-left: 10px;
  // // margin-right: 53px;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  // text-transform: uppercase;
  // color: #010101;
  color: #7d7d7d;
`;

const CountData = styled.div`
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 0 auto !important;
  // padding-right: 10px;

  font-weight: 900;
  font-size: 16px;
  line-height: 22px;
  text-align: right;
  color: #2b3c93;
`;

const FlexItem = styled.div`
  position: relative;
  margin-right: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center

  .FilterModalBtn {
    padding: 14px 70px !important;
  }


  .icon{
    position: absolute;
    color: #D9D9D9;
    top: 30px;
    right: 7px;
  }

  label{
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 19px;
    color: #010101;
    // margin-right: 30px;
    text-transform: capitalize;
  }

  .Select{
    width: 70% !important;
  }

  .datatime-wrapper{
    background: #fff;
    border-radius: 10px;
    border: none;
    padding: 2px;
  }

  @media (max-width: 760px)
  {
    margin-left: 0px;
    margin-bottom: 10px;
  }
  flex: 1;
  margin: 0;
  // margin-left: ${dimensions.coreSpacing}px;

  &:first-child {
    margin-left: 0;
  }

  .form-control {
    box-shadow: none;
    border-radius: 0;
    border: none;
    background: none;
    //border-bottom: 1px solid ${colors.colorShadowGray};
    padding: 17px 14px;
    font-size: ${typography.fontSizeBody}px;

    &:focus {
      box-shadow: none;
      border-color: ${colors.colorPrimary};
    }
  }


`;

const ItemSearch = styled.div`
  input {
    border-left: none;
    border-right: none;
    border-top: none;
    height: 34px;
    padding: 10px;
    border-radius: 0px;
  }
`;

const InsightFilter = styled.div`
  padding: 20px 30px;
  overflow-x: auto;
  height: calc(100vh - 60px);
  // // border-bottom: 1px solid ${colors.borderPrimary};
  // background: #f2f2f2;
  // border-radius: 20px 0px 0px 20px;
  // position:fixed;
  // height:100%;
  // width:400px;
  // overflow:auto;
  // right:0px;
  // top:0px;
  // z-index:999;
  // box-shadow: -10px 0px 20px rgba(0, 0, 0, 0.1);

  ::after{
    position: absolute;
    background-image: url(/images/new/slidebar-bg.png);
    z-index: -1;
    content: '';
    bottom: 0px;
    right: 0px;
    background-repeat: no-repeat;
    background-position: bottom right;
    width: 307px;
    height: 434px;
  }
  h5 {
    margin-top: 0;
  }

  .Select{
    //width: 50%;
    //z-index: 9;
  }

  .row div{
    margin-bottom:1px;
  }
`;

const InlineItems = styled.div`
  display: flex;
  margin-bottom: ${unitSpace};
  align-items: center;
  justify-content: space-between;

  > div {
    margin-right: ${unitSpace};
  }
`;

const TagsStyle = styled.div`
  border-radius: 14px;
  padding: 3px 9px;
  text-transform: uppercase;
  white-space: nowrap;
  font-size: 11px;
  display: inline-block;
  line-height: 1.32857;
  // background: #ebe2fe;
  margin-right: 5px;
  // color: ${colors.themeBlue};
  border: none;
  animation: 0s ease 0s 1 normal none running none;
`;

const AvtarImg = styled.div`
  display: inline-block;
  // width: 80px;
  // height: 80px;
  position: relative;
  margin-right: 15px;
  img {
    width: 50px;
    // height: 100%;
    // display: inline-block;
    // border-radius: 50%;
  }
  span {
    position: absolute;
    top: auto;
    bottom: 5px;
    right: 0px;
    background: #0161ed;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    line-height: 26px;
    text-align: center;

    i {
      color: #fff;
    }
  }
`;

const ProfileDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 20px;
  white-space: nowrap;

  span {
    float: right;
    margin-left: 20px;
    width: 100%;
    text-align: end;

    i {
      background: #ddd;
      border-radius: 5px;
      padding: 4px 6px 4px 6px;
    }
  }
`;

const UserName = styled.div`
  color: #303030;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;

  span {
    color: #a6a6a6;
    display: block;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
  }
`;

const SidebarBox = styled.div`
  border-radius: 10px;
  background: #ffffff;
  padding: 10px;
  margin: 20px;
  height: 90vh;
`;

const Header = styled.div`
  color: #000000;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  background: #f5f7f9;
  padding: 12px 20px;
  margin-bottom: 15px;
`;

const Body = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  margin: 0px;
`;
const BodyDiv = styled.div`
  padding: 4px 15px;

  .title {
    text-transform: capitalize;
    font-size: 13px;
    line-height: 18px;
  }

  .text {
    color: #000000;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    padding: 0px 0px 5px 0px;
    text-transform: capitalize;
  }
`;

const CustomTabs = styled.div`
  .nav-tabs {
    padding 5px 10px 0px;
  }
  .nav-tabs > li.active > a {
    border-bottom: 3px solid #2222FF;
    border-top: none;
    border-right: none;
    border-left: none;
    color: #303030;
  }
  .nav-tabs > li > a {
    color: #878582;
    outline: none;
    border-top: none;
    border-right: none;
    border-left: none;
    border-bottom: none;
  }
  .nav > li > a:focus,
  .nav > li > a:hover {
    //  border-color: transparent;
    background-color: transparent;
  }
`;

const Timeline = styled.div`
  padding-left: 30px;
  position: relative;

  .rs-timeline {
    direction: ltr;
    list-style: none;
    margin-bottom: 0;
    padding: 0;
  }

  .rs-timeline-align-left .rs-timeline-item {
    padding-left: 22px;
  }

  .rs-timeline-item {
    position: relative;
    text-align: left;
    margin-right: 20px;
  }

  .rs-timeline-item:first-child .rs-timeline-item-tail {
    top: 5px;
  }

  .rs-timeline-align-left .rs-timeline-item-tail {
    left: 4px;
  }

  .rs-timeline-item-tail {
    background-color: #d9d9d9;
    bottom: 0;
    position: absolute;
    top: 0;
    width: 2px;
  }

  .rs-timeline-align-left .rs-timeline-item-dot {
    left: 0;
  }

  .rs-timeline-item-dot {
    position: absolute;
    top: 5px;
  }

  .rs-timeline-item-dot:before {
    background-color: ${random_color};
    border-radius: 50%;
    content: "";
    display: block;
    height: 10px;
    width: 10px;
  }

  .rs-timeline-item:not(:last-child) .rs-timeline-item-content {
    padding-bottom: 15px;
  }

  .rs-timeline-item:last-child .rs-timeline-item-dot:before {
    background-color: #66cd2e;
  }

  .rs-timeline-item:last-child .rs-timeline-item-tail {
    bottom: auto;
    height: 15px;
  }

  .date {
    color: #303030;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    margin-right: 20px;
  }

  // .title {
  //   color: #A6A6A6;
  //   font-weight: 600;
  //   font-size: 14px;
  //   line-height: 21px;
  // }

  // .desc {
  //   font-weight: 400;
  //   font-size: 14px;
  //   line-height: 21px;
  //   letter-spacing: 0.03em;
  //   color: #303030;
  // }

  // .time {
  //   color: #A6A6A6;
  //   font-weight: 400;
  //   font-size: 14px;
  //   line-height: 21px;
  //   letter-spacing: 0.03em;
  // }
`;

const ActivityTitle = styled.h4`
  margin: 0;
  padding: ${dimensions.coreSpacing * 1.5}px 0 ${dimensions.coreSpacing}px;
  font-weight: 400;
  color: ${colors.textPrimary};
`;

const TitleAgent = styled.div`
  font-size: 14px;
  color: #303030;
  // padding-left: 40px;
  // padding-top: 18px;
  // margin-right: 10px;
  // margin-bottom: -15px;

  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 49px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #2b3c93;
  margin-left: 20px;

  @media only screen and (max-width: 767px) {
    font-size: 25px;
    margin-top: 20px;
    margin-left: 15px;
  }

  span {
    font-weight: 700;
  }
`;

const FilterOption = styled.div`
  border: 1px solid #30303066;
  box-shadow: 0px 6px 8px 0px #0000000f;
  width: 178px;
  height: 51px;
  background: #ffffff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;

  div {
    display: flex;
    align-items: center;
    font-weight: 400;
    letter-spacing: 0.05em;
    font-size: 14px;
    cursor: pointer;
    color: #acacac;

    path {
      stroke: #acacac;
    }

    &:hover,
    &:active {
      color: ${colors.themeBlue};
      font-weight: 600;

      path {
        stroke: ${colors.themeBlue};
      }
    }
  }

  span {
    margin-left: 5px;
  }
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 6px;

  img {
    width: 24px;
    height: 24px;
    border-radius: 50px;
    margin-right: 7px;
  }

  h6 {
    font-weight: 500;
    font-size: 14px;
    margin: 0px;
  }

  span {
    font-weight: 600;
    font-size: 14px;
    margin-left: 7px;
  }

  .time {
    width: 100%;
    text-align: right;
    color: #a6a6a6;
    font-weight: 500;
  }
`;

const UserTag = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 6px;

  span {
    font-weight: 400;
    font-size: 14px;
    color: #303030;
    letter-spacing: 0.03em;
    line-height: 21px;
    margin-right: 7px;
  }
`;

const UserNote = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 6px;

  span {
    font-weight: 400;
    font-size: 14px;
    color: #303030;
    letter-spacing: 0.03em;
    line-height: 21px;
    margin-right: 7px;
  }

  h6 {
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0.03em;
    color: #303030;
  }

  h5 {
    margin: 0;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0.03em;
    color: #303030;
    width: 100%;
    text-align: right;
    cursor: pointer;
  }
`;

const StateDataAgent = styled.div`
  display: flex;
  align-items: center;
  padding: 7px 0px;
`;

const ComponentBox = styled.div`
  background: #fff;
  height: calc(100vh - 190px);
  overflow: auto;
  padding: 20px;
`;

const DateView = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;

  .date {
    color: #303030;
    font-weight: 500;
    font-size: 16px;
    line-height: 21px;
    margin-right: 20px;
    letter-spacing: 0.8px;
  }

  hr {
    border-top: 0.9px dashed #ddd;
    width: 100%;
  }
`;

const DataViewList = styled.div`
  max-height: 70vh;
  overflow-y: auto;
`;
const DataView = styled.div`
  display: flex;
  // align-items: center;
  white-space: nowrap;
  .time {
    color: #7a7a8a;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0.8px;
    margin-right: 20px;
    margin-top: 20px;
  }
`;

const ContentData = styled.div`
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 10px;
  width: 100%;
  margin-bottom: 20px !important;
`;

const BoxData = styled.div`
  display: flex;
  white-space: nowrap;



    // &:before {
    //   background-color: #586874;
    //   width: 5px;
    //   height: 5px;
    //   border-radius: 50px;
    //   top: 0;
    //   left: 0;
    // }
  }
`;

const IconData = styled.div`
  margin-right: 20px;
  margin-top: 10px;
`;

const TagLine = styled.div`
  display: flex;
  align-items: center;

  h6 {
    font-weight: 500;
    font-size: 14px;
    margin: 0px;
    display: flex;
    align-items: center;

    &:after {
      content: "";
      background-color: #586874;
      width: 5px;
      height: 5px;
      border-radius: 50px;
      top: 0;
      display: block;
      margin-left: 7px;
      margin-right: 7px;
    }
  }

  span {
    color: #74818a;
    font-weight: 500;
    font-size: 14px;
    word-break: break-all;
    white-space: break-spaces;
  }
`;

const ProgressData = styled.div`
  // overflow-y : auto;
  // height: 120px;
`;

const DescData = styled.div`
  h6 {
    margin-bottom: 0px;
    font-size: 14px;
    font-weight: 600;
    white-space: normal;
    line-height: 1.5;
    letter-spacing: 0.03em;
  }

  div {
    font-size: 14px;
    white-space: normal;
    letter-spacing: 0.03em;
    line-height: 1.5;
  }

  span {
    color: ${colors.themeBlue};
    font-weight: 500;
    margin-left: 5px;
    cursor: pointer;
  }
`;

const ContentDataTheme = styled.div`
  border-radius: 10px;
  padding: 1px;
  // width: 100%;
  margin: 25px 170px;
  background: #fff;
`;

const ToggleArea = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  label {
    margin-left: 10px;
    margin-bottom: 0px;
  }
`;

const SkillWrapper = styled.div`
  max-height: 100%;
  inset: 0px;
  overflow: inherit;
  padding-left: 30px;
  padding-top: 30px;
  margin-right: 30px;
  margin-bottom: 30px;

  h4 {
    color: #303030;
    font-weight: 600;
    font-size: 22px;
    letter-spacing: 0.5px;
  }

  p {
    font-size: 14px;
  }

  .topHead {
    justify-content: space-between;
  }

  .topHead input[type="text"] {
    width: 410px;
    border-radius: 8px;
    padding: 8px 20px;
  }
`;

const TableData = styled.div`
  background: #eee;
  min-height: ${dimensions.headerSpacing}px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom: 1px solid #d1cccc;
  display: flex;
  justify-content: space-between;
  padding: 12px;
  // margin-top: 30px;
  // border-radius: 9px;
  align-items: center;

  label {
    color: ${colors.themeBlack};
    margin: 0px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.5px;
  }
`;

// const SkillWrapper = styled.div`
//   max-height: 100%;
//   inset: 0px;
//   overflow: inherit;
//   padding-left: 30px;
//   padding-top: 30px;
//   margin-right: 30px;
//   margin-bottom: 30px;

// `;

const InsightWrapper = styled.div`
  // position: absolute;
  // right: 0;
  // top: 0;
  // bottom: 0;
  // left: 0;
  // display: flex;
  // flex-direction: column;
  // flex: 1;
  // min-width: 480px;
  // border-radius: 20px;
  // margin-right: 20px;
  // margin-left: 20px;
  // width: 91%;

  background: #ffffff;
  //border-radius: 20px 0px 0px 20px;
  position: fixed;
  height: 100%;
  width: 460px;
  right: 0px;
  top: 0px;
  z-index: 99999;
  box-shadow: -10px 0px 20px rgb(0 0 0 / 10%);

  .filter-header-bar {
    cursor: pointer;
    z-index: 999;
    position: absolute;
    left: -58px;
    background: #2b3c93;
    color: #fff;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    display: flex;
    padding: 12px 15px 12px 19px;
  }

  @media screen and (max-width: 767px) {
    width: 400px;
    .filter-header-bar {
      position: relative;
      background: none;
      color: #000;
      left: 0;
    }
    .FilterModalBtn {
      padding: 14px 50px !important;
    }
  }
`;

export const SoundBox = styled.div`
  display: inline-flex;
  width: 200px;
  height: ${(props) => (props.height ? props.height : "200px")};
  background: #fff;
  border: 1px solid #f2f2f2;
  border-radius: 10px;
  margin: 10px 5px;
  padding: 10px;
  box-shadow: 0px 4px 24px rgb(0 0 0 / 10%);
  flex-direction: column;
`;

export const OnCallData = styled.div`
  .header {
    padding: 15px 20px 0px;
    background: #fff;
    box-shadow: 0px 3px 20px rgb(0 0 0 / 10%);
  }

  .nav {
    padding: 0px;
    background: #fff;
  }

  .nav-tabs > li > a {
    font-weight: 700;
  }

  .nav-tabs > li.active > a {
    color: #2222ff;
    font-weight: 700;
  }
`;

export const TimeData = styled.div`
  display: flex;
  align-items: center;
`;
export const TimeIcon = styled.div`
  color: #098109;
  margin-right: 6px;
`;
export const TimeInfo = styled.div`
  color: #098109;
  font-weight: 600;
  font-size: 16px;
  margin-right: 8px;
  display: flex;
  align-items: center;
`;
export const TimeDot = styled.div`
  background: #098109;
  width: 4px;
  height: 4px;
  border-radius: 50px;
  margin-left: 5px;
  margin-right: 5px;
`;

export const TimeVai = styled.div`
  color: #a6a6a6;
  font-weight: 500;
  font-size: 14px;
`;

export const TitleData = styled.div`
  color: #303030;
  font-weight: 700;
  font-size: 30px;
`;

export const FooterCall = styled.div`
  padding: 10px 30px;
  background: #fff;
  position: fixed;
  width: 95%;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 3px 20px rgb(0 0 0 / 10%);
`;

export const IconText = styled.div`
  display: flex;
  margin-right: 40px;
  align-items: center;
  .name {
    color: #303030;
    font-weight: 500;
    font-size: 14px;
    margin-left: 10px;
  }
`;

export const EndCall = styled.div`
  button {
    display: flex;
    align-items: center;
    padding: 6px 12px;
  }
  span {
    margin-right: 6px;
  }
`;

export const CallBody = styled.div`
  overflow-x: auto;
  max-height: calc(100vh - 270px);
  padding: 20px;
`;

export const InsideContent = styled.div`
  background: #fff;
  margin: 5px 10px 20px;
  box-shadow: 0px 3px 20px rgb(0 0 0 / 10%);

  .red {
    color: #ea475d;
    text-align: end;
    font-weight: 600;
    font-size: 14px;
  }

  > div {
    padding: 15px;
  }

  hr {
    margin: 0px;
  }

  h4 {
    font-weight: 500;
    margin-top: 0;
    font-size: 24px;
  }
`;

export const UserData = styled.div`
  display: flex;
  align-items: center;

  div {
    margin-left: 20px;
  }
  h4 {
    margin-bottom: 5px;
    font-weight: 700;
  }
  span {
    color: #a6a6a6;
  }
  h6 {
    margin: 0px;
    font-weight: 600;
    font-size: 14px;
  }
`;

export const AwardData = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: 10px;

  div {
    text-align: center;
    margin-left: 15px;
    margin-right: 15px;
  }

  i {
    width: 48px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-radius: 50%;
    display: inline-block;

    @media (max-width: 768px) {
      width: 60px;
      height: 60px;
      line-height: 60px;
    }
  }

  img {
    width: 48px;
    height: 48px;
  }

  @media (max-width: 768px) {
    img {
      width: 35px;
    }
  }

  span {
    display: block;
    padding: 5px 0px;
    color: #9b9b9b;
    white-space: no-wrap;
  }
`;

export const InfoData = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;

  > div {
    width: 100%;
  }
  span {
    color: #a6a6a6;
    font-siize: 12px;
  }
  p {
    margin: 0px;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
  }
`;

export const HistoryData = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  p {
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 0px;
  }
  span {
    margin-right: 5px;
    color: #a6a6a6;
  }
`;

export const InfosData = styled.div`
  .infos {
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      font-size: 15px;
      font-weight: 700;
      color: #303030;
    }

    p {
      color: #9b9b9b;
      margin-bottom: 0px;
      font-weight: 700;
    }
  }
  .progress {
    border-radius: 50px;
    margin-bottom: 8px;
    margin-top: 5px;
  }
  .progress-bar {
    width: 75%;
    background: #ea475d;
  }

  .red {
    display: flex;
    align-items: center;
    color: #ea475d;
    font-weight: 600;
    margin-bottom: 10px;

    span {
      margin-right: 6px;
    }
  }
`;

export const UserAvatar = styled.td`
  text-align: center;
  &:hover {
    cursor: pointer;
  }
`;

export const TimeLineStyle = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  justify-content: space-between;
  margin-bottom: 20px;

  h5 {
    margin: 0;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #bfbfbf;

    > p {
      margin: 0;
    }
  }

  .colorDark {
    color: #010101;
  }

  hr {
    width: 100%;
    margin: 0 10px;
    background: #f2f2f2;
  }
`;

export const OutBoundStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  label {
    font-weight: 700;
    font-size: 14px;
    line-height: 19px;
    color: #2b3c93;
    margin: 0;
    padding-left: 20px;
    text-transform: capitalize;
  }

  h6 {
    font-weight: 700;
    font-size: 14px;
    line-height: 19px;
    color: #010101;
  }

  span {
    label {
      text-align: left;
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      color: #010101;
      display: block;
      padding: 0;
      margin-bottom: 5px;
    }
  }
`;

export const UserHeaderData = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  td a {
    font-weight: 700;
    font-size: 18px;
    line-height: 25px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #010101;
  }
`;

export const UserBodyData = styled.div`
  background: #ffffff;
  box-shadow: 0px 4px 24px rgb(0 0 0 / 5%);
  border-radius: 10px;
  padding: 20px;
  margin-top: 20px;
  height: calc(100vh - 40px);
`;

export const ProfileDetails = styled.div`
  .bodyPart {
    background: #ffffff;
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    padding: 20px;

    label {
      font-weight: 700;
      font-size: 14px;
      line-height: 19px;
      color: #010101;
      text-transform: capitalize;
    }
  }

  .actions {
    display: flex;
    justify-content: end;
    span {
      background: #f2f2f2;
      border-radius: 5px;
      font-size: 18px;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const HeadingBold = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #010101;
`;

export const InsightRowData = styled.div``;
export const ProfileDivs = styled.div`
  display: flex;
  align-items: center;
  padding: 20px 10px 20px 20px;
  white-space: nowrap;
  background: #ececec;
  border-bottom: 1px solid #d9d9d9;

  .actions {
    margin-left: 20px;

    span {
      background: #ffffff;
      border-radius: 5px;
      font-size: 18px;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 700;
    }
  }
`;
export const AvtarImgs = styled.div`
  display: inline-block;
  position: relative;
  margin-right: 10px;

  img {
    width: 45px;
    height: auto;
  }
`;
export const UserNames = styled.div`
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  color: #010101;

  div {
    font-weight: 500;
    font-size: 11px;
    line-height: 15px;
    color: #b1b1b1;
    text-transform: capitalize;
  }
`;

export const ListData = styled.div`
  // background: #fafafa;
  display: flex;
  align-items: center;
  height: 48px;
  margin: 20px;
  justify-content: space-between;

  .actions_numbers {
    margin-left: 20px;

      span {
        background: #eff6f9;
        border-radius: 5px;
        font-size: 18px;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700
        font-size: 11px;
        line-height: 15px;
        color: #010101;
      }
  }
`;

export const ListImage = styled.div`
  display: inline-block;
  position: relative;
  margin-right: 10px;
  align-self: flex-start;

  img {
    width: 30px;
    border-radius: 50%;
  }
`;

export const ListName = styled.div`
  font-weight: 700;
  font-size: 11px;
  line-height: 15px;
  text-transform: uppercase;
  color: #010101;
  display: flex;
  flex-direction: column;

  div {
    font-weight: 500;
    font-size: 10px;
    line-height: 14px;
    color: #b1b1b1;
  }
`;

export const ProfileInfo = styled.div`
  background: #ffffff;
  // margin-right: -20px;
  // margin-top: -20px;
  padding: 20px 0px;

  .rightPart {
    img {
      width: 55px;
    }

    h6 {
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;
      color: #010101;
    }

    span {
      background: rgba(40, 166, 222, 0.05);
      border: 1px solid rgba(43, 60, 147, 0.1);
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      width: 35px;
      height: 35px;
    }
  }

  .infoData {
    height: 250px;
    overflow-y: overflow;
  }

  .info {
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-weight: 500;
      font-size: 14px;
      line-height: 19px;
      color: #b1b1b1;
      margin: 0px;
    }

    .value {
      font-weight: 700;
      font-size: 14px;
      line-height: 19px;
      color: #2b3c93;
      margin: 0px;
    }
  }
`;

export const InsightBodyData = styled.div`
  > div {
    background: none;
  }
`;

const ControlLabels = styled.div`
  line-height: 49px;
  font-size: 36px;
  font-weight: 700;
  margin: 0;
    height: auto;
  text-transform: uppercase;
  display: inline-flex;
  // font-weight: ${typography.fontWeightBold};
  color:#2B3C93;
  // font-size: ${typography.fontSizeHeading8}px;
  letter-spacing: 0.1em;
  @media (max-width: 767px) {
    font-size: 22px !important;
  }
`;

const ResponsiveBox = styled.div`
  padding: 0px 8px;
  width: 50% !important;
  @media (min-width: 300px) and (max-width: 860px) {
    width: 50% !important;
  }

  @media (max-width: 300px) {
    width: 100% !important;
  }
`;

const FileUploadLabel = styled.label`
  margin: 0 auto;
  color: #4860d9;

  .span {
    font-family: "Nunito";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
  }
`;

const HeaderAgent = styled.div`
  display: flex;
  align-items: center;
  padding: 9px 6px 9px 12px;
  border-bottom: 1px solid rgb(226, 232, 239);

  img {
    height: 25px;
    width: 30px;
  }

  h6 {
    font-size: 14px;
    font-weight: 500;
    line-height: 34px;
    letter-spacing: 0.03em;
    text-align: left;
    margin: 0px;
    padding-left: 10px;
  }
  button {
    margin-left: auto;
    // color: #49A0FF;
    // text-transform: capitalize;
    font-size: 16px;
  }
`;

export {
  FileUploadLabel,
  ResponsiveBox,
  MenuButton,
  OverviewLabel,
  BoxRoot,
  FullContent,
  ModalFooter,
  InfoWrapper,
  //AccountTable,
  Links,
  Well,
  FormWrapper,
  FormColumn,
  ColumnTitle,
  CenterContent,
  ActivityContent,
  DropIcon,
  InfoWrapperP,
  ModalButtonDesign,
  SimpleButton,
  CloseModal,
  DataWrapperClass,
  Title,
  Column,
  Columns,
  Box,
  RowTitle,
  Row,
  BoxName,
  AuthTextBox,
  InsightContent,
  InsightRow,
  LoaderWrapper,
  SummaryItem,
  SummaryIcon,
  SummaryTitle,
  SummaryCount,
  ChartWrapper,
  FlexRow,
  InsightTitle,
  StatusItem,
  StatusCount,
  StatusTitle,
  Group,
  Label,
  Value,
  InboundCall,
  AreaInner,
  OutboundCall,
  HeadingSpan,
  TotalCallItem,
  TotalCallTitle,
  TotalCallCount,
  NonProClass,
  SummaryNonItem,
  SummaryNonTitle,
  SummaryNonCount,
  StateData,
  CircleShape,
  TextData,
  TextDataa,
  CountData,
  FlexItem,
  InlineItems,
  InsightFilter,
  ItemSearch,
  TagsStyle,
  AvtarImg,
  ProfileDiv,
  UserName,
  SidebarBox,
  Header,
  Body,
  OverflowClass,
  BodyDiv,
  CustomTabs,
  Timeline,
  ActivityTitle,
  TitleAgent,
  FilterOption,
  UserInfo,
  UserTag,
  UserNote,
  StateDataAgent,
  ComponentBox,
  DateView,
  DataView,
  DataViewList,
  ContentData,
  BoxData,
  IconData,
  TagLine,
  ProgressData,
  DescData,
  LineShape,
  CircleShapes,
  ContentDataTheme,
  ClassForMargin,
  ClassForPadding,
  ToggleArea,
  SkillWrapper,
  TableData,
  EditorCSS,
  InsightWrapper,
  HeaderAgent,
};



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/styles/main.js